import React from 'react'
import { connect } from 'react-redux'
import Icon from '../../components/Icon/Icon'
import PropTypes from 'prop-types'
import './Ancillaries.scss'
import AncillariesContentBlock from './AncillariesContentBlock'
import FooterButton from '../../components/FooterButton/FooterButton'
import Container from '../../components/Container/Container'
import '../../static/scss/_variables.scss'
import objectContainsFalse from '../../helpers/objectContainsFalse'
import { tagAncillariesPage } from '../../helpers/tag/dynamicPageview'
import { validateAncillaries } from '../../actions/validation'
import { updateAncillaries } from '../../actions/ancillaries'
class Ancillaries extends React.Component {
  state = {
    labels: this.props.content('Ancillaries'),
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    tagAncillariesPage()
  }

  componentDidUpdate = prevProps => {
    const { ancillaries } = this.props
    if (prevProps.ancillaries !== ancillaries) {
      this.validateSelectedAncillaries(ancillaries)
    }
  }

  highlightError = () => {
    window.scrollTo(0, 0)
  }

  getErrorMessage = key => {
    const { labels } = this.state
    switch (key) {
      case '5B15':
      case '5B20':
        return labels['Hold luggage error']
      case 'SKIS':
        return labels['Ski luggage error']
      case 'GOLF':
        return labels['Golf luggage error']
      default:
        return ''
    }
  }

  validateSelectedAncillaries = ancillaries => {
    const { validateAncillaries } = this.props
    const { holdLuggage15, holdLuggage20, SKIS, GOLF } = ancillaries
    const totalPassengers = this.getPassengerCount()
    validateAncillaries({
      holdLuggage: holdLuggage15.value + holdLuggage20.value <= totalPassengers,
      SKIS: SKIS.value <= totalPassengers * 2,
      GOLF: GOLF.value <= totalPassengers * 2,
    })
  }

  handleChange = (key, value) => {
    const ancillaries = { ...this.props.ancillaries }
    ancillaries[key] = {
      ...ancillaries[key],
      value,
    }
    this.props.updateAncillaries(ancillaries)
  }

  getPassengerCount = () => {
    const [adults, children] = this.props.groupDetails.party
    return adults.value + children.value
  }

  getValidation = key => {
    const { validation } = this.props
    switch (key) {
      case '5B20':
        return validation.holdLuggage
      case 'SKIS':
        return validation.SKIS
      case 'GOLF':
        return validation.GOLF
      default:
        return true
    }
  }

  getLuggageBalance = key => {
    const { ancillaries } = this.props
    switch (key) {
      case '5B15':
        return ancillaries.holdLuggage20.value
      case '5B20':
        return ancillaries.holdLuggage15.value
      default:
        return 0
    }
  }

  getMaxValue = key => {
    const [adults, children] = this.props.groupDetails.party
    const amountOfPassengers = adults.value + children.value
    switch (key) {
      case '5B15':
      case '5B20':
        return amountOfPassengers
      case 'SKIS':
      case 'GOLF':
        return amountOfPassengers * 2
      default:
        return 999
    }
  }

  goToNextStep = () => {
    if (objectContainsFalse(this.props.validation)) {
      this.highlightError()
    } else {
      this.props.history.push('/booker-details')
    }
  }

  render() {
    const { ancillaries } = this.props
    const labels = this.state.labels
    return (
      <Container paddedBottom>
        <h1>
          <Icon name="medium-luggage" className="summary__icon -blue" />
          {labels && labels['Heading']}
        </h1>
        <div className="Ancillaries__content">
          <h3 className="Ancillaries__subHeading">
            <Icon name="medium-handluggage" className="summary__icon" />
            {labels && labels['Hand luggage']}
          </h3>
          <p>{labels && labels['Hand luggage description']}</p>
        </div>
        {Object.keys(ancillaries).map(key => {
          const ancillary = ancillaries[key]
          return (
            <AncillariesContentBlock
              title={labels[ancillary.labelId]}
              errorMessage={this.getErrorMessage(ancillary.key)}
              iconName={ancillary.icon}
              handleChange={this.handleChange}
              name={key}
              key={key}
              value={ancillary.value}
              maxValue={this.getMaxValue(ancillary.key)}
              luggageBalance={this.getLuggageBalance(ancillary.key)}
              isValid={this.getValidation(ancillary.key)}
            />
          )
        })}
        <FooterButton
          buttonAction={() => this.goToNextStep()}
          buttonContent={labels['Booker Details Button Label']}
          backButtonContent={labels['Return Button Label']}
          backButtonLink="/flight-offers"
          iconName="arrow-right"
        />
      </Container>
    )
  }
}

Ancillaries.propTypes = {
  groupDetails: PropTypes.shape({
    groupName: PropTypes.string,
    party: PropTypes.array,
  }),
  ancillaries: PropTypes.object,
  updateAncillaries: PropTypes.func,
  validation: PropTypes.object,
  validateAncillaries: PropTypes.func,
  content: PropTypes.func,
  history: PropTypes.object,
}

const mapStateToProps = state => {
  const {
    groupDetails,
    ancillaries,
    validation: { ancillaries: ancillariesValidation },
  } = state
  return {
    groupDetails,
    ancillaries,
    validation: ancillariesValidation,
  }
}

const mapDispatchToProps = {
  validateAncillaries,
  updateAncillaries,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Ancillaries)
